import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalColours {

  public static Map  = {
    'Job Ready': '#AEFFA1',
    'Employment Prep': '#FFE999',
    'Pre-Employment': '#FFA1B2',
    'Re-engagement': '#C9A1FF',
    "Prêt à l'emploi": '#AEFFA1',
    "Préparation à l`emploi": '#FFE999',
    "Pré-emploi": '#FFA1B2',
    "Réengagement": '#C9A1FF',
  }
}

